import React from 'react';

import { Link } from 'components/ui/link'
import { sharedActionCreators } from 'containers/shared';
import { connect } from 'containers/store';
import { GetConfigResponse } from 'generated/mos/admin/config';
import { pick } from 'helpers/core';
import { space } from 'helpers/style'
import { LayoutUnauthenticatedPage } from 'layouts/unauthenticated-page';
import styled from 'styled';

import { ForgotPasswordForm } from 'domains/account/components/forgot-password-form';


const Para = styled.p`
  margin-bottom: ${space(10)};
  text-align: center;
`;

const CtaContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${space(10)};
`

type DirectProps = {
  readonly onComplete: () => void;
};

type ConnectedProps = {
  readonly config: GetConfigResponse.Entity | undefined;
};

type ActionProps = Pick<typeof sharedActionCreators, 'toastNotification'>;

type Props = ActionProps & ConnectedProps & DirectProps;

const ForgotPasswordView = (props: Props) => {
  const { config, toastNotification } = props;
  if (!config) {
    return null;
  }

  if (!config.publicOrgInfo || !config.publicOrgInfo.orgRef) {
    return null;
  }

  const orgRef = config.publicOrgInfo.orgRef;

  return (
    <LayoutUnauthenticatedPage
      title={() => 'Forgot your password?'}
      content={() => (<>
        <Para>Please enter your email address and we will send you a link to reset your password.</Para>
        <ForgotPasswordForm
          orgRef={orgRef}
          onSuccess={() => {
            toastNotification({ type:'success', text: 'Email sent' });
            props.onComplete();
          }}
        />
        <CtaContainer>
          <Link to="/sign-in">
            Back to sign in
          </Link>
        </CtaContainer>
      </>)}
    />
  );
};

export const ForgotPasswordPage = connect<ConnectedProps, ActionProps, DirectProps>(
  (store) => pick(store.account, 'config'),
  pick(sharedActionCreators, 'toastNotification'),
)(ForgotPasswordView);
